import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useSidebar } from '@shared/ui/sidebar';

export const MobileMenuButton: React.FC = () => {
  let toggle = () => {};
  try {
    const sidebar = useSidebar();
    toggle = sidebar.toggleSidebar;
  } catch {
    // When rendered outside SidebarProvider
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      className="h-8 w-8 text-navbar-muted hover:text-navbar-foreground hover:bg-navbar-accent md:hidden shrink-0"
      aria-label="Toggle navigation menu"
    >
      <Menu className="h-4 w-4" />
    </Button>
  );
};
